import { useEffect, useState } from 'react';
import { AnimatedTypography } from './styled';
const FADE_DURATION = 400;
const VISIBLE_TIMER = 3000;
export function LoadingText(props) {
    const { texts, fontSize, fontWeight } = props;
    const [textIndex, setTextIndex] = useState(0);
    const text = texts[textIndex % texts.length];
    const [visibleText, setVisibleText] = useState(text);
    const inSync = text === visibleText;
    useEffect(() => {
        if (texts.length <= 1) {
            return undefined;
        }
        const interval = setInterval(() => {
            setTextIndex((i) => (i + 1) % texts.length);
        }, VISIBLE_TIMER);
        return () => {
            clearInterval(interval);
        };
    }, [texts.length]);
    return (<AnimatedTypography $visible={inSync} $transitionDuration={FADE_DURATION} $fontSize={fontSize} $fontWeight={fontWeight} onTransitionEnd={() => setVisibleText(text)}>
      {visibleText}
    </AnimatedTypography>);
}
